(function ($) {
	'use strict';

	$(function () {
		$('.js-lg-story-carousel').each(function () {
			const sliderContainer = $(this);
			const sliderEl = $('.swiper', sliderContainer)[0];
			const navParent = $('.js-lg-story-carousel-nav', sliderContainer);

			const swiper = new Swiper(sliderEl, {
				direction: 'horizontal',
				slidesPerView: 1,
				autoHeight: true,
				centeredSlides: true,
				speed: 1000,
				// autoplay: {
				// 	delay: 7000,
				// },
				loop: true,
				navigation: false,
				spaceBetween: 20,
				on: {
					beforeInit: function () {
						let numSlides = this.wrapperEl.querySelectorAll('.js-carousel-slide').length;

						if (numSlides <= 1) {
							navParent.css('display', 'none');
						}

						if (numSlides < 4) {
							this.params.loop = false;
						}
					},
					slideChange: function () {
						const currentSlide = [...sliderEl.querySelectorAll('.swiper-slide')][this.activeIndex];

						currentSlide.classList.add('is-visible');

						if (this.isBeginning) {
							$('.js-carousel-nav-prev', sliderContainer).addClass('is-disabled');
							$('.js-carousel-nav-prev', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-prev', sliderContainer).removeClass('is-disabled');
							$('.js-carousel-nav-prev', sliderContainer).removeAttr('disabled');
						}

						if (this.isEnd) {
							$('.js-carousel-nav-next', sliderContainer).addClass('is-disabled');
							$('.js-carousel-nav-next', sliderContainer).attr('disabled', 'disabled');
						} else {
							$('.js-carousel-nav-next', sliderContainer).removeClass('is-disabled');
							$('.js-carousel-nav-next', sliderContainer).removeAttr('disabled');
						}
					}
				},
			});

			$('.js-carousel-nav-next', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slideNext();
				});
			});

			$('.js-carousel-nav-prev', sliderContainer).each(function () {
				$(this).on('click', function () {
					swiper.slidePrev();
				});
			});
		});
	});
})(jQuery, document, window);
